export enum CalendarViewType {
    WEEK        = 'week',
    MONTH       = 'month',
    LIST        = 'list'
}

// export enum CalendarWeekView {
//     FULL_WEEK   = 'fullWeek',
//     WORK_WEEK   = 'workWeek'
// }

export enum CALENDAR_EVENT_PROJECT {
    PROJECT         = 'project',
    PROJECT_PATH    = 'project-path',
}

export const CALENDAR_COLOR_CONTRAST    = 'color'
export const CALENDAR_COLOR_PALE    = 'color-pale'
export const CALENDAR_NO_COLOR       = 'no-color'
export const CALENDAR_NO_USER_ICON= 'no-user-icon'

export const CALENDAR_HIGHLIGHT_OPTIONS : Option[] = [
    {
        value: CALENDAR_COLOR_CONTRAST,        label: 'Color (contrast)', icon: 'i5-contrast-max'
    },
    {
        value: CALENDAR_COLOR_PALE,            label: 'Color (pale)', icon: 'i5-contrast-min'
    },
    {
        value: CALENDAR_NO_COLOR,              label: 'No color', icon: 'i5-none'
    }
]


export const CALENDAR_VIEW_OPTIONS = [
    { id: 'month',   label: 'Month',  icon: 'i5-table',         info: 'View calendar by month' },
    { id: 'week',    label: 'Week',   icon: 'i5-board',         info: 'View calendar by weeks' },
    { id: 'list',    label: 'List',   icon: 'i5-dropdown',      info: 'View events list' }
];


export const SHOW_PROJECT_OPTIONS = [
    {value: null,                                   label: "Don't display"},
    {value: CALENDAR_EVENT_PROJECT.PROJECT,         label: "Show project"},
    {value: CALENDAR_EVENT_PROJECT.PROJECT_PATH,    label: "Show project path"},
]
